/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import defaultJsonColors from './colors.json'
import defaultJsonSet from './set.json'

import Box from './Box';

const App = () => {
	const [boxes, setBoxes] = useState(null);
	const [editingSet, setEditingSet] = useState(false);
	const [time, setTime] = useState(9000000);

	const colors = defaultJsonColors //['#bd5934', '#1e2ab3', '#c5b95a', '#117331', '#a5a592'];
	const defaultJson = JSON.stringify(defaultJsonSet) //'[{ "id": 1, "label": "Agurk", "bgColor": "#bd5934" }, { "id": 2, "label": "Avocado Hot", "bgColor": "#bd5934" }, { "id": 3, "label": "Laks Garlic", "bgColor": "#bd5934" }, { "id": 4, "label": "Spicy Veggie", "bgColor": "#bd5934" }, { "id": 5, "label": "Mango", "bgColor": "#bd5934" }, { "id": 6, "label": "Laks", "bgColor": "#bd5934" }, { "id": 7, "label": "Laks Spring", "bgColor": "#bd5934" }, { "id": 8, "label": "Seafood + Agurk", "bgColor": "#1e2ab3" }, { "id": 9, "label": "California", "bgColor": "#1e2ab3" }, { "id": 10, "label": "Spicy Shrimp", "bgColor": "#1e2ab3" }, { "id": 11, "label": "Mango Veggie", "bgColor": "#1e2ab3" }, { "id": 12, "label": "Spicy Seafood", "bgColor": "#1e2ab3" }, { "id": 13, "label": "Chicken Yummi", "bgColor": "#1e2ab3" }, { "id": 14, "label": "Chicken Nuts", "bgColor": "#1e2ab3" }, { "id": 15, "label": "Laks Royal", "bgColor": "#1e2ab3" }, { "id": 16, "label": "Laks Wasabi", "bgColor": "#c5b95a" }, { "id": 17, "label": "Laks Green", "bgColor": "#c5b95a" }, { "id": 18, "label": "Crispy Chicken", "bgColor": "#c5b95a" }, { "id": 19, "label": "Laks Mango", "bgColor": "#c5b95a" }, { "id": 20, "label": "Alaska", "bgColor": "#c5b95a" }, { "id": 21, "label": "Laks + Rejer", "bgColor": "#c5b95a" }, { "id": 22, "label": "California Royal", "bgColor": "#c5b95a" }, { "id": 23, "label": "Spicy Tun", "bgColor": "#c5b95a" }, { "id": 24, "label": "Tempura Royal", "bgColor": "#117331" }, { "id": 25, "label": "Avocado Tempura", "bgColor": "#117331" }, { "id": 26, "label": "Laks Dragon", "bgColor": "#117331" }, { "id": 27, "label": "Ebi Tempura", "bgColor": "#117331" }, { "id": 28, "label": "Crisy Torsk", "bgColor": "#117331" }, { "id": 29, "label": "Veggie Royal", "bgColor": "#117331" }, { "id": 30, "label": "Crispy Veggie", "bgColor": "#117331" }, { "id": 31, "label": "Tempura Nuts", "bgColor": "#117331" }, { "id": 32, "label": "Spicy Crispy Torsk", "bgColor": "#117331" }, { "id": 33, "label": "Tofu Nirigi", "bgColor": "#117331" }, { "id": 34, "label": "Laks Nigiri", "bgColor": "#117331" }, { "id": 35, "label": "Laks Garlic Nigiri", "bgColor": "#117331" }, { "id": 36, "label": "Lynstegt Laks Nigiri", "bgColor": "#117331" }, { "id": 37, "label": "Tun Nigiri", "bgColor": "#117331" }, { "id": 38, "label": "Spicy Tun Nigiri", "bgColor": "#117331" }, { "id": 39, "label": "Tun Mango Nigiri", "bgColor": "#117331" }, { "id": 40, "label": "Tigerreje Nigiri", "bgColor": "#117331" }, { "id": 41, "label": "Avocado Nigiri", "bgColor": "#117331" }, { "id": 42, "label": "Mango Nigiri", "bgColor": "#117331" }, { "id": 43, "label": "Ris 1", "bgColor": "#a5a592" }, { "id": 44, "label": "Ris 2", "bgColor": "#a5a592" }, { "id": 45, "label": "Ris 3", "bgColor": "#a5a592" }, { "id": 46, "label": "Ris 4", "bgColor": "#a5a592" }, { "id": 47, "label": "Ris 5", "bgColor": "#a5a592" }, { "id": 48, "label": "Ris 6", "bgColor": "#a5a592" }]';

	useEffect(() => {
		let jsonSetData = localStorage.getItem('jsonSetData');
		console.log(JSON.parse(jsonSetData));
		if (!jsonSetData) {
			localStorage.setItem('jsonSetData', defaultJson);
			jsonSetData = defaultJson;
		} else {
			jsonSetData = localStorage.getItem('jsonSetData');
		}

		let boxSet = JSON.parse(jsonSetData);

		if (!boxes) {
			setBoxes(boxSet);
		}

	}, []);

	const getTime = () => {
		return time;
	}

	const handleTimeChange = (event) => {
		setTime(event.target.value);
	}

	const renderBoxes = () => {
		return boxes.map((box, index) => {
			return <Box key={index} id={box.id} label={box.label} bgColor={box.bgColor} getTime={getTime} saveBox={saveBox} editingSet={editingSet} colors={colors} />
		});
	}

	const loadSet = () => {
		setEditingSet(false);

		let jsonSetData = localStorage.getItem('jsonSetData');
		let boxSet = JSON.parse(jsonSetData);

		setBoxes(boxSet);
	}

	const editSet = () => {
		if (editingSet) {
			setEditingSet(false);
		} else {
			setEditingSet(true);
		}
	}

	const saveSet = (updatedBoxes) => {
		let data = JSON.stringify(updatedBoxes);
		localStorage.setItem('jsonSetData', data);
	}

	const resetSet = () => {
		confirmAlert({
			title: 'Are you sure you want to reset the set?',
			message: '',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						localStorage.removeItem('jsonSetData');
						localStorage.setItem('jsonSetData', defaultJson);

						let boxSet = JSON.parse(defaultJson);
						setBoxes(null);
						setTimeout(() => {setBoxes(boxSet);}, 100)
					}
				},
				{
					label: 'No',
					onClick: () => {}
				}
			]
		});
	}

	const saveBox = (id, label, bgColor) => {
		const updatedBoxes = boxes.map(obj => {
			return obj.id === id ? { id: id, label: label, bgColor: bgColor } : obj;
		});

		setBoxes(updatedBoxes);

		saveSet(updatedBoxes);
	}

	const closeEditMode = () => {
		setEditingSet(false);
	}

	return (
		<>
			<div>
				<div style={{ marginBottom: 20 }}>
					<button onClick={loadSet} style={{ height: 40, marginRight: 20 }}>Load set</button>
					<button onClick={resetSet} style={{ height: 40, marginRight: 20 }}>Reset set</button>
					{editingSet ? <button onClick={closeEditMode} style={{ height: 40 }}>Close edit</button> : <button onClick={editSet} style={{ height: 40 }}>Edit set</button>}
				</div>
				<div style={{ marginBottom: 20 }}>
					<select onChange={handleTimeChange} style={{ width: 100, height: 40 }} defaultValue='9000000'>
						<option value='28800000'>8h00m set</option>
						<option value='9000000'>2h30m set</option>
					</select>
				</div>
			</div>
			{boxes ? renderBoxes() : ""}
		</>
	);
}

export default App;